// Types
import { AuthorizationConstants } from "Constants";
import { TUserDTO } from "Types";

export class UserLogic {

    public isFindestUser(user: TUserDTO): boolean {
        return user.roles.includes(AuthorizationConstants.FINDEST_ADMINISTRATOR_ROLE) || user.roles.includes(AuthorizationConstants.FINDEST_SCOUT_ROLE);
    }

}

export const UserLogicSingleton = new UserLogic();